import { Route, Routes, HashRouter } from 'react-router-dom'
import {
  Elements,
  Login,
  Welcome,
  Upload,
  UploadConfirmation,
  Contract,
  Author,
  Details,
  Finish,
} from './pages'
import { ProtectedRoute } from './components/'
import { AuthProvider } from './context/AuthProvider'
import './App.less'
import { UploadProcessProvider } from './context/UploadProcessProvider'
import { GoogleTagManagerProvider } from './context/GoogleTagManagerProvider'
export const WELCOME_ROUTE_PATH = '/welcome'
export const LOGIN_PATH = '/sign-in'
export const UPLOAD_ROUTE_PATH = '/'
export const CONFIRMATION_ROUTE_PATH = '/:submission_id/:id'
export const CONTRACT_ROUTE_PATH = `${CONFIRMATION_ROUTE_PATH}/contract`
export const AUTHOR_ROUTE_PATH = `${CONFIRMATION_ROUTE_PATH}/author`
export const DETAILS_ROUTE_PATH = `${CONFIRMATION_ROUTE_PATH}/details`
export const FINISH_ROUTE_PATH = `${CONFIRMATION_ROUTE_PATH}/finish`

const App = () => {
  return (
    <HashRouter basename="/">
      <GoogleTagManagerProvider>
        <AuthProvider>
          <UploadProcessProvider>
            <Routes>
              <Route path="/test" element={<Elements />} />
              <Route path={LOGIN_PATH} element={<Login />} />
              <Route
                path={WELCOME_ROUTE_PATH}
                element={
                  <ProtectedRoute>
                    <Welcome />
                  </ProtectedRoute>
                }
              />
              <Route
                path={UPLOAD_ROUTE_PATH}
                element={
                  <ProtectedRoute>
                    <Upload />
                  </ProtectedRoute>
                }
              />
              <Route
                path={CONFIRMATION_ROUTE_PATH}
                element={
                  <ProtectedRoute>
                    <UploadConfirmation />
                  </ProtectedRoute>
                }
              />
              <Route
                path={CONTRACT_ROUTE_PATH}
                element={
                  <ProtectedRoute>
                    <Contract />
                  </ProtectedRoute>
                }
              />
              <Route
                path={AUTHOR_ROUTE_PATH}
                element={
                  <ProtectedRoute>
                    <Author />
                  </ProtectedRoute>
                }
              />
              <Route
                path={DETAILS_ROUTE_PATH}
                element={
                  <ProtectedRoute>
                    <Details />
                  </ProtectedRoute>
                }
              />
              <Route
                path={FINISH_ROUTE_PATH}
                element={
                  <ProtectedRoute>
                    <Finish />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </UploadProcessProvider>
        </AuthProvider>
      </GoogleTagManagerProvider>
    </HashRouter>
  )
}

export default App
